// extracted by mini-css-extract-plugin
export default {"body":"Privacy_body__Il5Xo","inner":"Privacy_inner__VBxGP","content":"Privacy_content__uCbzh","privacy":"Privacy_privacy__ERJAy"};